import { render } from "./CodeReviewPush.vue?vue&type=template&id=07f535a4&scoped=true"
import script from "./CodeReviewPush.vue?vue&type=script&lang=js"
export * from "./CodeReviewPush.vue?vue&type=script&lang=js"

import "./codeReview.css?vue&type=style&index=0&id=07f535a4&scoped=true&lang=css&external"
import "./CodeReviewPush.vue?vue&type=style&index=1&id=07f535a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f535a4"]])

export default __exports__